var map = {
	"./classic.png": "1f88",
	"./classic_blue.png": "2982",
	"./classic_blue_print.png": "3de4",
	"./classic_gold.png": "794f",
	"./classic_gold_print.png": "9da7",
	"./classic_print.png": "05a3",
	"./galaxy_green.png": "66d5",
	"./galaxy_green_print.png": "7c1d",
	"./galaxy_purple.png": "33c4",
	"./galaxy_purple_print.png": "8dcb",
	"./modern_blue.png": "98d0",
	"./modern_blue_print.png": "e1dc",
	"./modern_pink.png": "feab",
	"./modern_pink_print.png": "3216",
	"./mystic_clouds.png": "e017",
	"./mystic_clouds_print.png": "4c3e",
	"./sparkling.png": "e5a9",
	"./sparkling_print.png": "245c",
	"./universe.png": "8d07",
	"./universe_print.png": "a55b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15bb";